import {useEffect} from "react";
import {useFormContext} from "react-hook-form";

import {InputField} from "@/components/form/fields/InputField/InputField.tsx";
import {ServerErrors} from "@/lib/types/common.ts";
import {IntegrationFormData} from "@/lib/types/integrations.ts";
import {SetupInfo} from "@/pages/integrations/edit/subForms/components/SetupInfo.tsx";
import {IntegrationModuleInfo, IntegrationModules} from "@/pages/integrations/integrations.types.ts";

export type FormValuesKey = keyof IntegrationFormData;

interface GoogleChatFormProps {
  serverErrors?: ServerErrors;
}

export const GoogleChatForm = ({serverErrors}: GoogleChatFormProps) => {
  const {setError} = useFormContext();

  useEffect(() => {
    if (serverErrors) {
      Object.keys(serverErrors)
        .filter((k) => k !== "__all__")
        .forEach((key) => setError(`settings.${key}` as FormValuesKey, {message: serverErrors[key][0]}));
    }
  }, [setError, serverErrors]);

  return (
    <>
      <div className="row row-cols-2 mb-3">
        <div className="col-12 mb-3">
          <InputField name="settings.webhook_url" label="Webhook URL" required={true} autoFocus={true} />
        </div>
      </div>
      <SetupInfo>
        <div className="p-2">
          In Google Chat, open the space where notifications should be posted. Click the space name, choose 'Apps &
          integrations', then 'Add webhooks'. Provide a name (e.g. Uptime.com), copy the generated webhook URL and paste
          it into the Webhook URL field above.
        </div>
        <div className="p-2">
          <a target="_blank" href="https://developers.google.com/workspace/chat/quickstart/webhooks">
            View {IntegrationModuleInfo[IntegrationModules.GOOGLE_CHAT].label} Webhook Documentation &rarr;
          </a>
        </div>
      </SetupInfo>
    </>
  );
};
